<div class="pd-container" *ngIf="product">

  <div class="gallery-section">
    <div class="main-image-wrapper">
      <model-viewer *ngIf="product.model3d"
                    [attr.src]="product.model3d"
                    [attr.alt]="product.name"
                    camera-controls auto-rotate rotation-per-second="30deg"
                    shadow-intensity="1" environment-image="neutral" exposure="1" class="viewer-3d">
        <div slot="poster" style="width: 100%; height: 100%; background: #f4f4f4;"></div>
      </model-viewer>

      <img *ngIf="!product.model3d" [src]="currentImage || product.image" [alt]="product.name">
    </div>
  </div>

  <div class="details-section">

    <div class="breadcrumbs">
      <span>SHOP</span> / <span>{{ product.categoryName || 'General' }}</span>
    </div>

    <h1 class="product-title">{{ product.name }}</h1>

    <div class="price-container">
      <span *ngIf="isOfferActive" style="text-decoration: line-through; color: #999; margin-right: 10px; font-size: 1.2rem;">
        {{ displayPrice | currency:'PEN':'symbol':'1.2-2' }}
      </span>
      <span class="product-price" [style.color]="isOfferActive ? '#e91e63' : '#000'">
        {{ (isOfferActive ? displayPriceOffer : displayPrice) | currency:'PEN':'symbol':'1.2-2' }}
      </span>
    </div>

    <p class="product-description">{{ product.description }}</p>

    <ul class="product-specs" *ngIf="product.sku || product.brandName">
      <li *ngIf="product.brandName"><span class="spec-label">Marca:</span> {{ product.brandName }}</li>
      <li *ngIf="product.sku"><span class="spec-label">Código:</span> {{ product.sku }}</li>
    </ul>

    <div class="controls-row">

      <div class="color-selector" *ngIf="product.color">
        <span class="label">Color</span>
        <div class="colors-grid">
          <div class="color-display"
               [style.background-color]="product.color"
               [title]="product.colorName || product.color"
               style="width: 30px; height: 30px; border-radius: 50%; border: 1px solid #ddd; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
          </div>
        </div>
      </div>

      <div class="size-selector" *ngIf="product.stockDetails && product.stockDetails.length > 0">
        <span class="label">Talla:</span>
        <div class="sizes-grid">
          <button *ngFor="let detail of product.stockDetails"
                  class="size-btn relative"
                  [class.active]="selectedSize === detail.sizeName"
                  [class.disabled]="detail.quantity === 0"
                  [disabled]="detail.quantity === 0"
                  (click)="selectSize(detail.sizeName!)">
            {{ detail.sizeName }}
            <span *ngIf="detail.quantity === 0"
                  class="absolute inset-0 flex align-items-center justify-content-center text-red-500 font-bold bg-white opacity-80"
                  style="font-size: 1.2rem;">X</span>
          </button>
        </div>
      </div>

      <div class="qty-selector">
        <span class="label">Cantidad:</span>
        <div class="qty-controls">
          <button class="qty-btn" (click)="decreaseQty()" [disabled]="quantity === 1">−</button>
          <span class="qty-number">{{ quantity }}</span>
          <button class="qty-btn" (click)="increaseQty()"
                  [disabled]="!selectedSize || quantity >= selectedStock">+</button>
        </div>
      </div>

    </div>

    <div class="mt-3 mb-3">
      <div *ngIf="product.stock === 0" class="text-red-600 font-bold bg-red-50 p-2 text-center border-round">
        PRODUCTO AGOTADO
      </div>

      <div *ngIf="selectedSize && selectedStock > 0 && selectedStock <= 10" class="text-orange-600 text-sm font-bold flex align-items-center gap-2">
        <span>¡Corre! Solo quedan {{selectedStock}} unidades en talla {{selectedSize}}.</span>
      </div>
    </div>

    <button class="add-btn"
            (click)="addToCart()"
            [disabled]="isAddToCartDisabled || selectedStock === 0">

      <ng-container *ngIf="product.stock === 0">AGOTADO</ng-container>

      <ng-container *ngIf="product.stock > 0">
        <span *ngIf="!selectedSize">Selecciona una talla</span>

        <span *ngIf="selectedSize">
         Añadir al Carrito -
          {{ (isOfferActive ? displayPriceOffer : displayPrice) * quantity | currency:'PEN':'symbol':'1.2-2' }}
     </span>
      </ng-container>

    </button>
  </div>
</div>

<div *ngIf="!product && isLoading" style="padding-top: 150px; text-align: center;">
  Cargando producto...
</div>
<div *ngIf="!product && !isLoading" style="padding-top: 150px; text-align: center;">
  Producto no encontrado.
</div>